var map = {
	"./ABC.svg": "0809",
	"./BCCB.svg": "9c14",
	"./BEAI.svg": "8298",
	"./BOCOM.svg": "b3f3",
	"./BOCSH.svg": "5f45",
	"./BOHC.svg": "ce4e8",
	"./BOJS.svg": "be8f",
	"./BOS.svg": "56cf",
	"./BRCB.svg": "3e98",
	"./CCB.svg": "94f3",
	"./CEB.svg": "41a4",
	"./CIB.svg": "0a15",
	"./CMB.svg": "07f0",
	"./CMBC.svg": "0c62",
	"./CNCB.svg": "bad7",
	"./ChinaY.svg": "9e8b",
	"./DLCB.svg": "17c8",
	"./Dashboard1.svg": "95a9",
	"./GDB.svg": "bb03",
	"./GZCB.svg": "86b2",
	"./HXB.svg": "a0d9",
	"./HZCB.svg": "9f2a",
	"./ICBC.svg": "15a5",
	"./NJCB.svg": "fa98",
	"./PAB.svg": "7f07",
	"./PSBC.svg": "53e1",
	"./QDCB.svg": "fb46",
	"./SPDB.svg": "1ba8",
	"./SRCB.svg": "f473",
	"./Users.svg": "7f92",
	"./add.svg": "c2a3",
	"./agent.svg": "1586",
	"./camera.svg": "8ce0",
	"./card.svg": "2d9e",
	"./compute.svg": "bdb7",
	"./creditcard.svg": "8089",
	"./delete.svg": "59a1",
	"./distribute.svg": "3b2f",
	"./doc.svg": "7ec4",
	"./domesticWallet.svg": "a1c2",
	"./email.svg": "cbb7",
	"./envelope.svg": "64e1",
	"./example.svg": "30c3",
	"./export.svg": "077e",
	"./eye_close.svg": "919c",
	"./eye_open.svg": "062e",
	"./feeDetail.svg": "8eae",
	"./feeManage.svg": "e6a0",
	"./feeReconciliation.svg": "8dba",
	"./form.svg": "eb1b",
	"./haiwaishoukuanA.svg": "d78c",
	"./haiwaishoukuanB.svg": "7607",
	"./hook.svg": "12db",
	"./key.svg": "e7b0",
	"./link.svg": "18f0",
	"./lock.svg": "ab00",
	"./lock_password.svg": "1e31",
	"./miniprogram.svg": "d2ed",
	"./multiwallet.svg": "b214",
	"./nested.svg": "dcf8",
	"./offline.svg": "058b",
	"./online.svg": "a3a7",
	"./overseas.svg": "2580",
	"./paid.svg": "ab7a",
	"./password.svg": "2a3d",
	"./people.svg": "d056",
	"./personAdd.svg": "fed2",
	"./personal.svg": "ce9e",
	"./phone.svg": "dd82",
	"./purchase.svg": "b8f7",
	"./question.svg": "ae00",
	"./receipt.svg": "2824",
	"./reconciliation.svg": "3d73",
	"./setting.svg": "05ff",
	"./shoppingCart.svg": "1882",
	"./sub.svg": "0cbc",
	"./table.svg": "47f1",
	"./terms.svg": "dfe1",
	"./tip.svg": "f943",
	"./tree.svg": "93cd",
	"./upload.svg": "9d82",
	"./user.svg": "b3b5",
	"./vcc.svg": "876c",
	"./wallet.svg": "402b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";